import React from 'react';

const LandscapeInsightPanel = ({
  landscapeData,
  showLandscapeCharts,
  setShowLandscapeCharts,
  setPage,
  user
}) => {
  return (
    <>
            {landscapeData && (
              <div style={{
                marginBottom: '16px',
                padding: '16px',
                backgroundColor: '#f0f9ff',
                borderRadius: '8px',
                border: '1px solid #bae6fd'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#0369a1', marginBottom: '8px' }}>
                      📊 Landscape Insight
                    </div>
                    
                    {/* Filing Trend - Clear with timeframe */}
                    <div style={{ marginBottom: '12px' }}>
                      <div style={{ fontSize: '12px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>
                        Filing Trend {landscapeData.comparison_years && `(${landscapeData.comparison_years})`}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{
                          fontSize: '20px',
                          fontWeight: '600',
                          color: landscapeData.trend_direction === 'increasing' ? '#16a34a' :
                                 landscapeData.trend_direction === 'decreasing' ? '#dc2626' : '#64748b'
                        }}>
                          {landscapeData.trend_direction === 'increasing' ? '↑' :
                           landscapeData.trend_direction === 'decreasing' ? '↓' : '→'}
                          {landscapeData.trend_percentage !== 0 && ` ${Math.abs(landscapeData.trend_percentage)}%`}
                        </span>
                        <span style={{ fontSize: '14px', color: '#475569' }}>
                          {landscapeData.trend_description || (
                            landscapeData.trend_direction === 'increasing' ? 'Increasing activity' :
                            landscapeData.trend_direction === 'decreasing' ? 'Decreasing activity' : 'Stable activity'
                          )}
                        </span>
                      </div>
                      <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>
                        Based on patents matching your search
                      </div>
                    </div>

                    {/* Top Assignees */}
                    {landscapeData.top_assignees_preview?.length > 0 && (
                      <div style={{ marginBottom: '12px' }}>
                        <div style={{ fontSize: '12px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>
                          Top Filers in This Space
                        </div>
                        <div style={{ fontSize: '14px', color: '#1e293b' }}>
                          {landscapeData.top_assignees_preview.slice(0, 3).map((a, i) => (
                            <span key={i}>
                              <strong>{a.name}</strong> ({a.count}){i < Math.min(2, landscapeData.top_assignees_preview.length - 1) ? ', ' : ''}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Interpretation Hints */}
                    {landscapeData.interpretation_hints?.length > 0 && (
                      <div style={{ 
                        marginTop: '12px', 
                        padding: '10px 12px', 
                        background: landscapeData.trend_direction === 'decreasing' ? '#fef3c7' : '#ecfdf5',
                        borderRadius: '6px',
                        border: landscapeData.trend_direction === 'decreasing' ? '1px solid #fcd34d' : '1px solid #a7f3d0'
                      }}>
                        <div style={{ fontSize: '12px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>
                          💡 What this might mean:
                        </div>
                        <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '13px', color: '#4b5563' }}>
                          {landscapeData.interpretation_hints.map((hint, idx) => (
                            <li key={idx} style={{ marginBottom: '2px' }}>{hint}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                  <button
                    onClick={() => setShowLandscapeCharts(!showLandscapeCharts)}
                    style={{
                      background: landscapeData.full_access ? '#0369a1' : '#64748b',
                      color: 'white',
                      padding: '8px 16px',
                      borderRadius: '6px',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: '500',
                      marginLeft: '16px',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {landscapeData.full_access
                      ? (showLandscapeCharts ? 'Hide Charts' : 'See Full Breakdown →')
                      : '🔒 Upgrade for Charts'
                    }
                  </button>
                </div>


                
                {/* Expanded Charts - Only for Premium/Pro */}
                {showLandscapeCharts && landscapeData.full_access && (
                  <div style={{ marginTop: '20px', borderTop: '1px solid #bae6fd', paddingTop: '20px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
                      {/* Filing Trends */}
                      <div style={{ backgroundColor: 'white', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                        <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#334155' }}>Filing Trends by Year</h4>
                        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '2px', height: '150px' }}>
                          {landscapeData.filing_trends?.slice(-15).map((item, i) => {
                            const maxCount = Math.max(...landscapeData.filing_trends.slice(-15).map(d => d.count));
                            const barHeight = maxCount > 0 ? Math.max(4, (item.count / maxCount) * 130) : 4;
                            return (
                              <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', height: '100%' }}>
                                <div
                                  style={{
                                    width: '100%',
                                    backgroundColor: '#0369a1',
                                    height: `${barHeight}px`,
                                    borderRadius: '2px 2px 0 0'
                                  }}
                                  title={`${item.year}: ${item.count} patents`}
                                />
                                <span style={{ fontSize: '9px', color: '#64748b', marginTop: '4px', transform: 'rotate(-45deg)', whiteSpace: 'nowrap' }}>
                                  {item.year}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      
                      {/* Top Assignees */}
                      <div style={{ backgroundColor: 'white', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                        <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#334155' }}>Top Assignees</h4>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          {landscapeData.top_assignees?.slice(0, 8).map((item, i) => {
                            const maxCount = landscapeData.top_assignees[0]?.count || 1;
                            const widthPct = (item.count / maxCount) * 100;
                            return (
                              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <div style={{ width: '120px', fontSize: '11px', color: '#334155', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.name}>
                                  {item.name}
                                </div>
                                <div style={{ flex: 1, backgroundColor: '#e2e8f0', borderRadius: '4px', height: '16px' }}>
                                  <div style={{ width: `${widthPct}%`, backgroundColor: '#0369a1', height: '100%', borderRadius: '4px' }} />
                                </div>
                                <span style={{ fontSize: '11px', color: '#64748b', width: '40px', textAlign: 'right' }}>{item.count}</span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    
                    {/* CPC Distribution */}
                    <div style={{ marginTop: '16px', backgroundColor: 'white', padding: '16px', paddingBottom: '40px', borderRadius: '8px', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
                      <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#334155' }}>Technology Areas (CPC Codes)</h4>
                      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '4px', height: '120px', marginBottom: '20px' }}>
                        {landscapeData.cpc_distribution?.slice(0, 10).map((item, i) => {
                          const maxCount = Math.max(...landscapeData.cpc_distribution.slice(0, 10).map(d => d.count));
                          const barHeight = maxCount > 0 ? Math.max(4, (item.count / maxCount) * 100) : 4;
                          return (
                            <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', height: '100%' }}>
                              <div
                                style={{
                                  width: '100%',
                                  backgroundColor: '#06b6d4',
                                  height: `${barHeight}px`,
                                  borderRadius: '2px 2px 0 0'
                                }}
                                title={`${item.code}: ${item.count} patents`}
                              />
                              <span style={{ fontSize: '8px', color: '#64748b', marginTop: '24px', transform: 'rotate(-45deg)', whiteSpace: 'nowrap' }}>
                                {item.code}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                  </div>
                )}
                
                {/* Upgrade Prompt for Free Users */}
                {showLandscapeCharts && !landscapeData.full_access && (
                  <div style={{ 
                    marginTop: '16px', 
                    padding: '20px', 
                    backgroundColor: '#fef3c7', 
                    borderRadius: '8px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '15px', color: '#92400e', marginBottom: '12px' }}>
                      <strong>Upgrade to Premium</strong> to see full landscape visualizations including filing trends, competitor analysis, and technology breakdowns.
                    </div>
                    <button style={{
                      background: '#f59e0b',
                      color: 'white',
                      padding: '10px 24px',
                      borderRadius: '6px',
                      border: 'none',
                      cursor: 'pointer',
                      fontWeight: '600'
                    }} onClick={() => setPage(user ? 'pricing' : 'register')}>
                      Upgrade Now
                    </button>
                  </div>
                )}
              </div>
            )}
    </>
  );
};

export default LandscapeInsightPanel;
